module.exports = __webpack_public_path__ + "img/pencil.8d59694b.svg";